import { message } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import successIcon from '../../assets/images/success-icon.svg';

export const showCustomSuccessMessage = (msg: string = ''): void => {
  const key = Date.now();
  message.open({
    key,
    type: 'success',
    icon: (
      <img
        src={successIcon}
        alt=''
        className='custom-success-toast-icon'
        width={20}
        height={20}
      />
    ),
    content: (
      <div className='custom-success-toast-body'>
        <span>{msg}</span>
        <CloseOutlined
          className='custom-success-toast-close'
          onClick={() => message.destroy(key)}
        />
      </div>
    ),
    className: 'custom-success-toast',
  });
};
